package com.dotdrives.config

import kotlin.String

internal object BuildKonfig {
  public val SUPABASE_URL: String = "https://jswdskeuudgqzaoqmcww.supabase.co"

  public val SUPABASE_PUBLISHABLE_KEY: String = "sb_publishable_9ChkX6yIbmQACBOTWROvnQ_BEQreNFa"
}
